import { serviceURL } from "../../../../utils/service-url";

export function makePollUrl(accountId: string, optionId: string): string {
  return `${serviceURL("poll-position")}poll_response/${accountId}/${optionId}`;
}
